import { NgModule } from '@angular/core';
import { CityEventBuilder } from './city-event.builder';

/* eslint-disable no-useless-constructor */
@NgModule({})
export class CityEventModule {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  constructor(_cityEventBuilder: CityEventBuilder) {}
}
